<template>
  <ion-page id="move-page">
    <ion-content>
      <div v-show="showTour">
        <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
      </div>

      <div id="the_board" :style="styleBoard">
        <CMChessboard :fen="fen" :orientation="orientation" :boardSize="boardSize" 
          :validMoves="availableMoves" :sparePieces="sparePiecesNewWay"   
          :emitPosition="emitPosition" :doEmitEveryMove="doEmitEveryMove"
          :setSquareColor="squareColorArray"
          @board-position="boardPosition" @move-made="moveMade"
         />
      </div>

      <div id="the_statusline" :style="styleStatus">
        <span v-if="showThumb == 'down'">
          <ion-icon aria-hidden="true" :icon="thumbsDown" />
          <ion-icon aria-hidden="true" :icon="thumbsDown" />
        </span>
        <span v-if="showThumb == 'up'">
          <ion-icon aria-hidden="true" :icon="thumbsUp" />
          <ion-icon aria-hidden="true" :icon="thumbsUp" />
        </span>
        {{ statusString }}
        <span v-if="showThumb == 'down'">
          <i class="fa fa-thumbs-down"></i> 
          <ion-icon aria-hidden="true" :icon="thumbsDown" />
          <ion-icon aria-hidden="true" :icon="thumbsDown" />
        </span>
        <span v-if="showThumb == 'up'">
          <ion-icon aria-hidden="true" :icon="thumbsUp" />
          <ion-icon aria-hidden="true" :icon="thumbsUp" />
        </span>
        <br>
        {{ instructionString }}
        <div v-show="showMoveTextString.length > 0">
          {{ showMoveTextString }}
        </div>
      </div>
  
      <ActionSheet :heading="actionSheetHeading" :items="actionSheetButtons" 
                    :trigger="actionSheetTrigger"
                    @action-sheet-result="actionSheetResult">
      </ActionSheet>
    </ion-content>
    <Toolbar id="the_toolbar" :elements="toolbarElements" :ignoreClicks="showTour" 
                    :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>
  
<script setup>

  import { IonIcon,IonPage, IonContent,modalController } from '@ionic/vue';
  import { thumbsUp, thumbsDown } from 'ionicons/icons';

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'
  import ModalMoveSpecificPieces from '@/components/ModalMoveSpecificPieces.vue'
  import ActionSheet from '@/components/ActionSheet.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import Toolbar from '@/components/Toolbar.vue'
  import CMChessboard from '@/components/CMChessboard.vue'
  // import GenericListVue from '@/components/GenericList.vue'
  // import RandomSpecificPieces from '@/components/RandomSpecificPieces.vue'

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { t } from "@/composables/translateText.js";

  import { ref, watch } from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useGetData } from '@/composables/getData.js'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { availableWidthHeight, calculateChessBoardRect , isScreenPortraitOrientation } from '@/composables/screenSize'
  import Tour from '@/components/Tour.vue'

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  const actionSheetHeading = ref(t("Options"))
  const emitPosition = ref(0)
  const doEmitEveryMove = ref(true)

  // passed 'random' 'begin' 'pieces' as 2nd parameter in header2
  var moveFollowingType = connectionStore.getProductOption

  const STATE_WAITING = 0
  const STATE_SHOWING_PIECES = 1
  const STATE_USER_REPLICATING = 2
  const STATE_SHOWING_RIGHT_ANSWER = 3 
  const STATE_SHOWING_USER_ANSWER = 4

  var problemState = STATE_WAITING

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  const EMPTY_FEN = "8/8/8/8/8/8/8/8 w KQkq - 0 1"

  const orientation = ref("white")
  const fen = ref(EMPTY_FEN)
  var fenid = 0
  var currentUserFen = ""
  var answerFen = EMPTY_FEN
  var desiredOption = ""
  var currentPiecesOption = 0
  var currentMoveOption = 0
  var currentAnnounceOption = 0
  var currentShowMoveOption = 0
  var firstMoveNumber = 0
  var isRandom = 0

  var specificPiecesOptionString = ""
  const MOVE_FOLLOWING_BEGINNING_GAME = 1
  const MOVE_FOLLOWING_BEGINNING_CONTINUATION = 2
  const MOVE_FOLLOWING_RANDOM_GAME_LOCATION = 3
  const MOVE_FOLLOWING_RANDOM_PIECES = 4

  var optionDisplayArray = []
  var optionDisplaySelected = ""
  var optionHeading = ""

  // which option is being worked on in generic list
  var whichOptionIsGenericList = ""

  const toolbarTrigger = ref(0)

  const makeAnyMoves = [ { from : "any"}]
  const makeNoMoves = [ ]

  const availableMoves = ref(makeNoMoves)

  const sparePiecesOldWay = ref(true)
  const sparePiecesNewWay = ref("move")

  const boardSize = ref(300)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const STATUS_FONTSIZE = 20
  const STATUS_HEIGHT = STATUS_FONTSIZE * 1.2 + 4
  
  const statusString = ref(t("Click 'Get Next' to Begin"))
  const instructionString = ref("")
  const showMoveTextString = ref("")

  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  //console.log("*** Tour option",tourOption)
  const showTour = ref((tourOption == "show"))

  var requestType = 0

  // track moves made so we can undo them
  var undoFenStack = []
  var blankAppendTrigger = ""

  const squareColorArray = ref([])

  const showThumb = ref("")

  const ActionStrings = {
        mine : t("Show Mine"),
        replicate : t("Replicate") + "!",
        answer : t("Show Actual"),
        check : t("Check Work")
  }

  const TOOLBAR_GET_NEXT = 0
  const TOOLBAR_ACTIVITY = 1
  const TOOLBAR_UNDO = 2
  const TOOLBAR_OPTIONS = 3

  const toolbarElements = ref([
    { index : TOOLBAR_GET_NEXT, label : t("Get Next") ,disabled : false },
    { index : TOOLBAR_ACTIVITY, label : ActionStrings.replicate ,disabled : true },
    { index : TOOLBAR_UNDO, label : t("Undo") ,disabled : true },
    { index : TOOLBAR_OPTIONS, label : t("Options") ,disabled : false, hasAction : true }
  ])

  const ACTION_OPTION_PIECES = 0
  const ACTION_OPTION_MOVES = 1
  const ACTION_OPTION_ANNOUNCE = 2
  const ACTION_OPTION_ONE_AT_A_TIME = 3
  const ACTION_OPTION_SPECIFIC_PIECES = 4

  // OPTIONS Action sheet
  const actionSheetTrigger = ref(0)
  var actionSheetButtons = []

  const actionMoveFollowingSheetButtons = [
        { text: t("Piece Count"), data: { index: ACTION_OPTION_PIECES } },
        { text: t("# of Moves"), data: { index : ACTION_OPTION_MOVES } },
        { text: t("Announce Moves"), data: { index : ACTION_OPTION_ANNOUNCE } },
        { text: t("Show 1 Move at time"), data: { index : ACTION_OPTION_ONE_AT_A_TIME } },
        { text: t("Cancel"), role: 'cancel',data: { index : -1}},
    ];
  const actionSpecificPiecesSheetButtons = [
        { text: t("Specific Pieces"), data: { index: ACTION_OPTION_SPECIFIC_PIECES } },
        { text: t("Cancel"), role: 'cancel',data: { index : -1}},
    ];


  //console.log("move following",moveFollowingType)
  setMoveFollowingType()

    // tour stuff
  const tourInfo = ref({
    id : "move_following",
    video : "",
    elements : [
      { id: "", title: t("Move Sequence Visualization"), text : t("This exercise will help you visualize a sequence of moves. You're shown a board position and then told the sequence of white and black moves. At the end of the move sequence, you will update the board to match the now current position.")},
      { id: "", title: t("First Variation"), text : t("<b>Moves At Random Location</b> - Visualize a sequence of moves from a random point in a real game.")},
      { id: "", title: t("Second Variation"), text : t("<b>Moves From Beginning of Game</b> - Gives you the option of playing through an entire real game a given set of moves at a time.")},
      { id: "", title: t("Third Variation"), text : t("<b>Follow Specific Pieces</b> - Want to focus on specific pieces? <br><br>The toolbar 'Options' will enable you to select the specific pieces you want to do work with")},
      { id: "the_toolbar", title: t("Get Next - Toolbar"), text : t("Will display the board just before the move sequence")},
      { id: "the_toolbar", title: t("Replicate - Toolbar"), text : t("When you're ready, the 'Replicate' button will unlock the pieces ready for you to place them on the squares where they should be at the end of the move sequence.")},
      { id: "the_toolbar", title: t("Check Work - Toolbar"), text : t("Done placing the pieces?<br><br>'Check Work' will tell you how well you did.<br><br>The button title will change to 'Show Mine' and 'Show Actual' so you can toggle back and forth.")},
      { id: "the_toolbar", title: t("Options - Toolbar"), text : t("For all variations, you can select:<br><b>Number of Moves</b> - # of moves in the sequence<br><b>Announce Moves</b> - Want to hear the moves spoken?<br><b>Show 1 Move At a Time</b> - You can either see all the moves at once or just one at a time")},
      { id: "the_toolbar", title: t("Random Locations"), text : t("For <b>Random Location</b> you select how many pieces you want to work with")},
      { id: "the_toolbar", title: t("Specific Pieces"), text : t("For <b>Specific Pieces</b> you select the combination of pieces you want to work with")}
    ]
  })

  var currentOneAtATimeIndex = 0
  var showAll = 0
  var playAudio = 0
  var moveStrings = []
  var moveWords = []
  var moveText = ""
  var lastFenid = 0
  var moveCount = 0
  var gameId = 0
  var lastSequenceNumber = 0

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleStatus = ref({
    "text-align" : "center",
    "font-size" : "16px",
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    menuTrigger.value++
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  function setMoveFollowingType() {
    if (moveFollowingType == "random") {
      actionSheetButtons = actionMoveFollowingSheetButtons
      requestType = MOVE_FOLLOWING_RANDOM_GAME_LOCATION
      instructionString.value = t("Random Start")
    }
    else
    if (moveFollowingType == "pieces") {
      actionSheetButtons = actionSpecificPiecesSheetButtons
      requestType = MOVE_FOLLOWING_RANDOM_PIECES;
      instructionString.value = t("Random Pieces")
    }
    else {
      actionSheetButtons = actionMoveFollowingSheetButtons
      requestType = MOVE_FOLLOWING_BEGINNING_GAME
      toolbarElements.value[TOOLBAR_GET_NEXT].label = t("Game Start")
      instructionString.value = t("At Game Start");
    }
    toolbarTrigger.value++
  }

  function tourDone() {
    showTour.value = false
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boardSize.value + "px"
    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"

    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleStatus.value.height = boundaries['status'].height + "px"
    styleStatus.value.width = boundaries['status'].width + "px"
    styleStatus.value.top = boundaries['status'].top + "px"
    styleStatus.value.left = boundaries['status'].left + "px"

    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                    calculateLandscapeWidthHeights(availableSpace)

    updateStyleObjects(boundaries)
    
  }

  function calculatePortraitWidthHeights(availableSpace) {

    // reserve space for moves
    const availableSpaceForBoard = { width : availableSpace.width ,
              height : availableSpace.height - 100,
              isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = boardPositionTop + boardHeight
    const statusPositionLeft = availableSpace.leftRightIndent
    const statusWidth = availableSpace.width - availableSpace.leftRightIndent * 2
    const statusHeight = availableSpace.height - statusPositionTop

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    // reserve space status message
    const availableSpaceForBoard = { width : availableSpace.width - 150,
              height : availableSpace.height ,
              isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)
      
    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = 0
    const statusPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const statusHeight = availableSpace.height - statusPositionTop
    const statusWidth = availableSpace.width - statusPositionLeft

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** static board -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** REP TREE new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  watch(() => connectionStore.getProductOption, () => { 
    //console.log("#################### move type changed")
    moveFollowingType = connectionStore.getProductOption
    setMoveFollowingType()
  })

  function boardPosition(fen) {
    //console.log("fen back from board",fen)
    currentUserFen = fen
    checkFen(currentUserFen)
  }

  function moveMade(moveFen,uci) {
    //console.log("MOVE MADE",moveFen,uci)
    undoFenStack.push(moveFen)
    toolbarElements.value[TOOLBAR_UNDO].disabled = false
  }

   // Start ACTION LIST

   function actionClick(index) {
  
    switch (index) {
      case ACTION_OPTION_PIECES :
        desiredOption = "pieces"
        optionHeading = t("Set # of Pieces on Board")
        getOptions()
        break
      case ACTION_OPTION_MOVES :
        desiredOption = "moves"
        optionHeading = t("# of Moves in Sequence")
        getOptions()
        break
      case ACTION_OPTION_ANNOUNCE :
        desiredOption = "announce"
        optionHeading = t("Announce Moves")
        getOptions()
        break
      case ACTION_OPTION_ONE_AT_A_TIME :
        desiredOption = "one"
        optionHeading = t("Show only one move at a time?")
        getOptions()
        break
      case ACTION_OPTION_SPECIFIC_PIECES :
        getSpecificPieceOptions("initial")
        break
    }
  }

  function actionSheetResult(action,index) {
    if (action != "yes")
      return
    actionClick(index)
  }

  // END Action List

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == optionDisplaySelected)
        return

      //console.log("CONFIRM in move",data)

      if (desiredOption == "pieces")
        setOptions(data.selected,currentMoveOption,currentAnnounceOption,currentShowMoveOption)
      else
      if (desiredOption == "moves")
        setOptions(currentPiecesOption,data.selected,currentAnnounceOption,currentShowMoveOption)
        else
      if (desiredOption == "announce")
        setOptions(currentPiecesOption,currentMoveOption,data.selected,currentShowMoveOption)
      else
      if (desiredOption == "one")
        setOptions(currentPiecesOption,currentMoveOption,currentAnnounceOption,data.selected)
    }
  };
  // END Generic Options List

  // START Move Specific Pieces

  const openMoveSpecificPiecesModal = async () => {
    const modal = await modalController.create({
      component: ModalMoveSpecificPieces,
      componentProps: {
        optionString : specificPiecesOptionString
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == optionDisplaySelected)
        return

      //console.log("CONFIRM in specific pieces",data)
      setSpecificPieceOptions(data.selected)
    }
  };
  // END Move Specific Pieces


  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function toolbarClick(arrayIndex) {
    if (arrayIndex < 10 && toolbarElements.value[arrayIndex].disabled)
      return

    switch (arrayIndex) {
      case TOOLBAR_UNDO :
        incrementAppendTrigger()
        if (undoFenStack.length > 0)
          undoFenStack.pop()
        const backFen = (undoFenStack.length > 0) ? undoFenStack[undoFenStack.length - 1] : currentUserFen
        fen.value = backFen + blankAppendTrigger
        if (undoFenStack.length == 0) {
          toolbarElements.value[TOOLBAR_UNDO].disabled = true
          toolbarTrigger.value++
        }
        break
      case TOOLBAR_OPTIONS :
        //console.log("Click on Options")
        actionSheetTrigger.value++
        break
      case TOOLBAR_GET_NEXT :
        getMoveSequence(requestType)
        break
      case TOOLBAR_ACTIVITY :
        // state 1 is we have a board with visible pieces.  need to visualize
        //console.log("problem state at action",problemState)
        if (problemState == 10) {
          if (currentOneAtATimeIndex < moveStrings.length) {
            // do one move at a time if either visual or spoken

            if (playAudio == 1)
              saySomething(moveWords[currentOneAtATimeIndex]);

            if (showAll == 0)
              instructionString.value = moveStrings[currentOneAtATimeIndex]

            currentOneAtATimeIndex++;
          }
          else {
            problemState = 1;
            toolbarClick(TOOLBAR_ACTIVITY);
          }
          break
        }
        if (problemState == 1) {
          // the board has visible pieces.  This click, removes the move list and put in mode of user replicating
          problemState = 2
          availableMoves.value = makeAnyMoves
          toolbarElements.value[TOOLBAR_ACTIVITY].label = t("Check Work")
          instructionString.value = ""
          showMoveTextString.value = ""
          toolbarTrigger.value++
        }
        else
        if (problemState == STATE_USER_REPLICATING) {
          toolbarElements.value[TOOLBAR_UNDO].disabled = true
          availableMoves.value = makeNoMoves
          emitPosition.value++
        }
        else
        if (problemState == STATE_SHOWING_RIGHT_ANSWER) {
          problemState = STATE_SHOWING_USER_ANSWER
          fen.value = currentUserFen
          statusString.value = t("Board Shows Your Answer")
          toolbarElements.value[TOOLBAR_ACTIVITY].label = ActionStrings.answer
          toolbarTrigger.value++
        }
        else
        if (problemState == STATE_SHOWING_USER_ANSWER) {
          problemState = STATE_SHOWING_RIGHT_ANSWER
          fen.value = answerFen
          statusString.value = t("Board Shows Actual Answer")
          toolbarElements.value[TOOLBAR_ACTIVITY].label = ActionStrings.mine
          toolbarTrigger.value++
        }
        break
    }
  }

  // https://dev.to/asaoluelijah/text-to-speech-in-3-lines-of-javascript-b8h

  function saySomething(moveString) {
    if ('speechSynthesis' in window) {
      // Speech Synthesis supported 🎉
      //console.log("speech synthesis supported",moveString)
      var msg = new SpeechSynthesisUtterance()
      msg.text = moveString
      window.speechSynthesis.speak(msg)
    }
    else {
      // Speech Synthesis Not Supported 😣
      //alert("Sorry, your browser doesn't support text to speech!");
    }
  }

  function processJsonResponse(json) {
    //console.log("response from move following",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    // reset the undo stack
    toolbarElements.value[TOOLBAR_UNDO].disabled = true
    undoFenStack = []

    currentOneAtATimeIndex = 0
    showAll = json['showall']
    playAudio = json['playaudio']

    moveStrings = json['movetext'].split("!")
    moveWords = json['sans_words'].split("\t")
    moveText = json['movetext'].replace(/!/g," ")
    fen.value = json['fenboard']
    currentUserFen = fen.value
    fenid = json['fenid']
    lastFenid = json['lastfenid']
    moveCount = json['movecount']
    gameId = json['gameid']
    lastSequenceNumber = json['is_last_sequence']

    firstMoveNumber = json["firstmovenum"]
    isRandom = json["is_random"]

    // if at the beginning of the board, shift to continuing game
    if (requestType == MOVE_FOLLOWING_BEGINNING_GAME)
      requestType = MOVE_FOLLOWING_BEGINNING_CONTINUATION

    // if we are doing the "beginning of the game" types and we've run out this game, queue to get beginning next time
    if (requestType == MOVE_FOLLOWING_BEGINNING_CONTINUATION && lastSequenceNumber > 0)
        requestType = MOVE_FOLLOWING_BEGINNING_GAME

    // show all moves and don't say them

    //console.log("move text",moveText)

    showMoveTextString.value = ""

    if (showAll == 1 && playAudio == 0) {
      instructionString.value = t("Visualize the following moves") + ": " + moveText
      problemState = STATE_SHOWING_PIECES
      toolbarElements.value[TOOLBAR_GET_NEXT].label = t("Give Up")
      toolbarElements.value[TOOLBAR_ACTIVITY].label = ActionStrings.replicate
      toolbarElements.value[TOOLBAR_ACTIVITY].disabled = false
    }
    else {
      problemState = 10;
      instructionString.value = t("Tap the button for the first move")
      if (showAll == 0 && playAudio == 1)
        toolbarElements.value[TOOLBAR_ACTIVITY].label = t("Show and Say Move")
      else
        if (playAudio == 1)
          toolbarElements.value[TOOLBAR_ACTIVITY].label = t("Say Move")
        else
          toolbarElements.value[TOOLBAR_ACTIVITY].label = t("Show Move")

      if (showAll == 1) {
        instructionString.value = t("Visualize the following moves") + ":\n" + moveText
      }
      toolbarElements.value[TOOLBAR_ACTIVITY].disabled = false
    }

    squareColorArray.value = []

    toolbarTrigger.value++

    showThumb.value = ""
    statusString.value = ""
  }

  function getMoveSequence(what) {

    var formData = {
      what : what
    }

    //console.log("move sequence #",what)
    useGetData("get41_random_move.php", formData, processJsonResponse)
  }
  
  function processCheckFenJsonResponse(json) {
    //console.log("response from check fen",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    toolbarElements.value[TOOLBAR_GET_NEXT].label = t("Get Next")
    toolbarTrigger.value++

    problemState = STATE_SHOWING_RIGHT_ANSWER

    const errorCount = json['diff']

    if (errorCount == 100) {
      toolbarElements.value[TOOLBAR_ACTIVITY].disabled = true
      statusString.value = t("Nothing Attempted")
      instructionString.value = ""
      showThumb.value = ""
      return
    }
    if (errorCount == 0) {
      statusString.value = t("No Errors") + "!"
      showThumb.value = "up"
      instructionString.value = ""
      toolbarElements.value[TOOLBAR_ACTIVITY].label = t("No Errors")
      toolbarElements.value[TOOLBAR_ACTIVITY].disabled = true
      return
    }

    const targets = json['wtarget'].split(" ")
    const tries = json['wtry'].split(" ")

    var bads = []
    for (var i = 0; i < targets.length; i++) {
      var found = 0
      for (var j=0; j < tries.length; j++)
        if (tries[j] == targets[i]) {
          found = 1
          break
        }
      if (found == 0)
        bads.push({square : targets[i], color : "red"})
    }
    for (var i = 0; i < tries.length; i++) {
      var found = 0
      for (var j=0; j < targets.length; j++)
        if (tries[j] == targets[i]) {
          found = 1
          break
        }
      if (found == 0)
        bads.push({square : tries[i], color : "red"})
    }

    answerFen = json['ofen']
    statusString.value = t("Board Shows Actual Answer")

    squareColorArray.value = bads

    if (errorCount == 1)
      instructionString.value = "1 " + t("Error")
    else
      instructionString.value = errorCount + " " + t("Errors")

    showMoveTextString.value = t("For Review") + ": " + moveText
    toolbarElements.value[TOOLBAR_ACTIVITY].label = ActionStrings.mine
    fen.value = answerFen
  }

  function checkFen(fen) {

    var formData = {
      id : lastFenid,
      timestepping : 0,
      timeupdate : 0,
      fen : fen,
      ismove : 1,
      eval : 0,
      initfenid : fenid,
      moves : moveCount,
      gameid : gameId,
      blackfirst : 0,
      firstmovenum : firstMoveNumber,
      israndom : isRandom
    }
    //console.log("formdata for check_fen",formData)
    useGetData("check_fen.php", formData, processCheckFenJsonResponse)
  }

  function specificPiecesDone(didChange,s) {
    if (didChange == false)
      return
    setSpecificPieceOptions(s)
  }

  function processGetOptionsJsonResponse(json) {
    //console.log("response from options",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    var initial = ""

    optionDisplayArray = []

    switch (desiredOption) {
      case "pieces" :
        for (var i = 3; i <= 32; i++) {
          const oneItem = { 
            index : i,
            name : i + " " + t("Pieces"),
            id : i,
            radio : "" + i
          }
          optionDisplayArray.push(oneItem)
        }
        initial = json['p']
        break
      case "moves" :
        for (var i = 1; i <= 10; i++) {
          const moveString = (i == 1) ? t("Move") : t("Moves")
          const oneItem = { 
            index : i,
            name : i + " " + moveString,
            id : i,
            radio : "" + i
          }
          optionDisplayArray.push(oneItem)
        }
        initial = json['m']
        break
      case "announce" :
        optionDisplayArray = [
          { index : 0, name : t("Yes"),id : 1,radio : "1" },
          { index : 1, name : t("No"),id : 0,radio : "0" },
        ]
        initial = json['move_audio']
        break
      case "one" :  
        optionDisplayArray = [
          { index : 0, name : t("Yes"),id : 1,radio : "1" },
          { index : 1, name : t("No"),id : 0,radio : "0" },
        ]
        initial = json['show_move']
        break
    }

    currentPiecesOption = json['p']
    currentMoveOption = json['m']
    currentAnnounceOption = json['move_audio']
    currentShowMoveOption = json['show_move']

    optionDisplaySelected = "" + initial
    openGenericSingleListModal()
  }

  function getOptions() {

    var formData = {
      p : 0,
      c : 0,
      m : 0,
      move_audio : 0,
      show_move : 0
    }
    useGetData("get50_set_moveoptions.php", formData, processGetOptionsJsonResponse)
  }

  function processSetOptionsJsonResponse(json) {
    //console.log("response from options",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }

  function setOptions(pieceCount,moveCount,announce,showMove) {

    var formData = {
      p : pieceCount,
      c : 0,
      m : moveCount,
      move_audio : announce,
      show_move : showMove
    }
    //console.log("set options",formData)
    useGetData("get50_set_moveoptions.php", formData, processSetOptionsJsonResponse)
  }

  function processGetSpecificPieceOptionsJsonResponse(json) {
    //console.log("response from specific piece options",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    specificPiecesOptionString = json['mobile']
    openMoveSpecificPiecesModal()
  }

  function getSpecificPieceOptions(v) {
    var formData = {
      v : v
    }
    useGetData("get_set_randomoptions.php", formData, processGetSpecificPieceOptionsJsonResponse)
  }

  function processSetSpecificPieceOptionsJsonResponse(json) {
    //console.log("response from specific piece options",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }

  function setSpecificPieceOptions(v) {

    var formData = {
      v : v
    }
    useGetData("get_set_randomoptions.php", formData, processSetSpecificPieceOptionsJsonResponse)
  }
</script>

<style scoped>

</style>
